import { useModal } from '#/zustand-stores/modalStore';

import { ModalByType } from './ModalByType';

export function ModalRoot() {
  const { modal } = useModal();
  if (!modal) return null;

  return <ModalByType type={modal.type} modalProps={modal.props} />;
}
